
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"56","height":"56","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"id-41a","width":"146.7%","height":"150%","x":"-23.3%","y":"-17.9%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0 0 0 0 0 0.0165552526 0 0 0 0 0.454313859 0 0 0 0.208479021 0"}})]),_c('path',{attrs:{"id":"id-42b","d":"M19 15v3a1 1 0 00.883.993L20 19h3a1 1 0 00.993-.883L24 18v-3h8v3a1 1 0 00.883.993L33 19h3a1 1 0 00.993-.883L37 18v-3h4a2 2 0 012 2v22a2 2 0 01-2 2H15a2 2 0 01-2-2V17a2 2 0 012-2h4zm3-2a1 1 0 011 1v3a1 1 0 01-1 1h-1a1 1 0 01-1-1v-3a1 1 0 011-1h1zm13 0a1 1 0 011 1v3a1 1 0 01-1 1h-1a1 1 0 01-1-1v-3a1 1 0 011-1h1z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"28","cy":"28","r":"28","fill":"#53CB72"}}),_c('use',{attrs:{"fill":"#000","filter":"url(#id-41a)","xlink:href":"#id-42b"}}),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#id-42b"}}),_c('path',{attrs:{"fill":"#53CB72","fill-opacity":".262","d":"M17 22h4v4h-4zM17 31h4v4h-4zM26 22h4v4h-4zM26 31h4v4h-4zM35 22h4v4h-4z"}})])])
          )
        }
      }
    